import { createContext, useEffect, useState } from "react";
import axios from '../axios';

export const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [authReady, setAuthReady] = useState(false);

    useEffect(() => {
        const autoLogin = async () => {
            const token = sessionStorage.getItem("access_token");

            if (token) {
                setAuthReady(true);
                return;
            }

            try {
                const res = await axios.post("app-token", {
                    app_key: "DOTIGO_APP_KEY",
                });

                console.log("Auto login successful:", res.data);

                sessionStorage.setItem("access_token", res.data.access);
                sessionStorage.setItem("refresh_token", res.data.refresh);
                setAuthReady(true);
            } catch (error) {
                console.log(error);
                alert("Auth Error");
            }
        };

        autoLogin();
    }, []);

    if (!authReady) {
        return <div>Loading...</div>;
    }

    return (
        <AuthContext.Provider value={{ authReady }}>
            {children}
        </AuthContext.Provider>
    );
}